import { api } from "lib/graphql/api"
import { gql } from "@apollo/client"
import { mutate } from "lib/graphql/mutate"

export const approveDraftReview = api(async function approveDraftReview({ projectId, scheduleId, amendIds = [] }) {
    if (!projectId || !scheduleId || !amendIds.length) return false

    return mutate(
        gql`
            mutation ApproveDraftReview($projectId: String!, $scheduleId: String!, $amendIds: [String!]!) {
                approveDraftReview(projectId: $projectId, scheduleId: $scheduleId, amendIds: $amendIds)
            }
        `,
        { projectId, scheduleId, amendIds },
        { returns: "approveDraftReview" }
    )
})
